<script>
export default {
  name: "auction-status",
  props: {},
  data: function() {
    return {};
  },
  methods: {
    formatDate: function(date) {
      return formatDate(date, true, true);
    },
    formatTime: function(time) {
      return formatTime(time);
    },
  },
  computed: {
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    activeAuctionStatus: function() {
      return this.$store.state.activeAuction.status;
    },
    auctionTimePassed: function() {
      return this.$store.state.auctionTimePassed;
    },
    auctionStart: function() {
      return this.formatDate(this.$store.state.activeAuction.auctionStart);
    },
  },
};
</script>
<template>
  <button v-if="auctionId" type="button" class="btn btn-light status-button " :class="`status-${activeAuctionStatus.replace(/\s/g, '-').toLowerCase()}`">
    <span v-if="activeAuctionStatus == 'Complete'">Auction has ended</span>
    <span v-else-if="activeAuctionStatus == 'In Progress'">Auction in Progress</span>
    <span v-else-if="activeAuctionStatus == 'Unstarted'">
      <span v-if="auctionTimePassed < -600">Auction will start at {{ auctionStart }}</span>
      <span v-else-if="auctionTimePassed < 0">Auction will start in {{ formatTime(Math.abs(auctionTimePassed)) }}</span>
    </span>
  </button>
</template>
<style scoped>
.status-button {
  width: 100%;
  font-size: 18px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  pointer-events: none !important;
}
.start-auction:hover {
  text-decoration: underline;
}
.start-auction {
  font-weight: normal;
}
</style>
